/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function FreezeColumn({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M11.799 7.099c.266 0 .482.216.482.482v.897l.475-.444a.482.482 0 1 1 .659.703l-1.134 1.062v.917h1.011l.955-1.117a.482.482 0 0 1 .732.627l-.418.49h.856a.483.483 0 0 1 0 .965h-.942l.473.457a.483.483 0 0 1-.67.694l-1.195-1.15h-.802v.816l1.14 1.108a.482.482 0 1 1-.672.691l-.468-.455v.975a.483.483 0 0 1-.965 0v-.902l-.498.41a.483.483 0 0 1-.611-.746l1.11-.913v-.985H10.5l-1.107 1.14a.482.482 0 1 1-.692-.672l.454-.468h-.973a.483.483 0 0 1 0-.965h.901l-.41-.498a.483.483 0 0 1 .747-.611l.911 1.11h.985v-.918l-1.133-1.062a.483.483 0 0 1 .66-.703l.473.443v-.896c0-.266.217-.482.483-.482M12.5.6a2.6 2.6 0 0 1 2.6 2.6v3.165c0 .453-.652.687-1.008.406a.49.49 0 0 1-.192-.383V3.2a1.4 1.4 0 0 0-1.4-1.4h-9a1.4 1.4 0 0 0-1.4 1.4v9a1.4 1.4 0 0 0 1.4 1.4h3.4a.6.6 0 0 1 0 1.2H3.5a2.6 2.6 0 0 1-2.6-2.6v-9A2.6 2.6 0 0 1 3.5.6z" /><path fill="currentColor" d="M4.7 11.7a.6.6 0 1 1-1.2 0v-8a.6.6 0 1 1 1.2 0z" /></svg>;
}
;